exports.parseMidi = require('./lib/midi-parser')
exports.writeMidi = require('./lib/midi-writer')
